import { render } from "./linkClub.vue?vue&type=template&id=4bf4e6ba&scoped=true"
import script from "./linkClub.vue?vue&type=script&lang=js"
export * from "./linkClub.vue?vue&type=script&lang=js"

import "./linkClub.vue?vue&type=style&index=0&id=4bf4e6ba&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf4e6ba"]])

export default __exports__